import { render } from "./NavigationMenu.vue?vue&type=template&id=d4e0137a"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=d4e0137a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NavigationMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4e0137a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4e0137a', __exports__)) {
    console.log('reload')
    api.reload('d4e0137a', __exports__)
  }
  
  module.hot.accept("./NavigationMenu.vue?vue&type=template&id=d4e0137a", () => {
    console.log('re-render')
    api.rerender('d4e0137a', render)
  })

}


export default __exports__